<template>
  <div>
    <bridge8-popover
      :header-prefix="headerPrefix"
      trigger="click"
      :obj="obj"
      :text-callback="obj => obj.name"
    />
  </div>
</template>

<script>
import {OrderTypes} from '../enums'
import Bridge8Popover from './Bridge8Popover'
import {capitalize} from '../utils'

export default {
  name: 'OrdersTableCellPartner',
  props: {
    row: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator: str => Object.values(OrderTypes).includes(str)
    }
  },
  computed: {
    headerPrefix: function () {
      return `${capitalize(this.type)}: `
    },
    obj: function () {
      return this.row[this.type]
    }
  },
  components: {
    Bridge8Popover
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OrdersTableCellPartner.vue